import React, { useState, useEffect } from 'react';

export default function LoaderWheel(props) {
  return <i className="fas fa-spinner fa-spin ml-2"></i>;
}
